import React, { FC } from 'react'

import { Routes } from 'common/constants'
import { formatDate } from 'pages/your-personal-data/components/reports-history/utils/functions'
import { reportTypeToFriendlyNameMapper } from 'pages/your-personal-data/components/reports-history/utils/mappers'
import { useAppContext } from 'contexts/app-context/hooks/useAppContext'

import IcChevronRight from '@interco/icons/core/action-navigation/ic_chevron_right'
import { Text } from '@interco/inter-ui/components/Text'

import { Report } from '../../../types/YourPersonalData.types'
import { AvailableReport, ReportMetadata, RequestedReport } from './styles'

export const ReportCard: FC<Report> = (report) => {
  const { userLanguage } = useAppContext()

  if (!userLanguage) return null

  return report.status === 'COMPLETED' ? (
    <AvailableReport to={Routes.REPORT_LOADER} state={{ ...report }}>
      <ReportMetadata>
        <Text variant="body-3" colorWeight={500} bold as="p">
          {reportTypeToFriendlyNameMapper[report.requestType][userLanguage]}
        </Text>
        <Text variant="caption-1" colorWeight={500} as="p">
          {formatDate('FULL_DATE', userLanguage, report.requestDate)}
        </Text>
      </ReportMetadata>
      <IcChevronRight height={24} width={24} color="var(--secondary500)" />
    </AvailableReport>
  ) : (
    <RequestedReport>
      <ReportMetadata>
        <Text variant="body-3" colorWeight={500} bold as="p">
          {reportTypeToFriendlyNameMapper[report.requestType][userLanguage]}
        </Text>
        <Text variant="caption-1" colorWeight={500} as="p">
          {formatDate('FULL_DATE', userLanguage, report.requestDate)}
        </Text>
      </ReportMetadata>
    </RequestedReport>
  )
}
